import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button';
import { Input } from './Input';
import css from './Newsletter.css';

const Newsletter = ({ onSendEmail }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const subscribeUserToNewsletter = async (userEmail) => {
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      await onSendEmail(userEmail);
      setSuccessMessage('¡Te has suscrito exitosamente al newsletter!');
    } catch (error) {
      setErrorMessage('Hubo un error al suscribirte, intenta de nuevo.');
    } finally {
      setEmail('');
      setIsLoading(false);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Por favor, ingresa un correo válido.');
      return;
    }

    subscribeUserToNewsletter(email);
  };

  useEffect(() => {
    if (successMessage || errorMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(null);
        setErrorMessage(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [successMessage, errorMessage]);

  return (
    <div className={css.newsletterContainer}>
      <div className={css.newsletter}>
        <h2 className={css.title}>
          Suscríbete al Newsletter para enterarte de lo más HOT que hay en Gloset, antes de que te lo ganen.
        </h2>
        <form onSubmit={onSubmit} className={css.form}>
          <Input
            type="email"
            placeholder="Ingresa tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
          <Button
            type="submit"
            disabled={isLoading}
            variant="outline"
            className={css.subscribeButton}
          >
            {isLoading ? 'Suscribiendo...' : 'Suscríbete'}
          </Button>
        </form>

        {errorMessage && (
          <p className={css.errorMessage}>{errorMessage}</p>
        )}

        {successMessage && (
          <p className={css.successMessage}>{successMessage}</p>
        )}
      </div>
    </div>
  );
};

Newsletter.propTypes = {
  onSendEmail: PropTypes.func.isRequired,
};

export default Newsletter; 